import React, { Component } from "react";
import flashLogo from "assets/img/flash_color_logo_text@3x.png";
import { Grid, Row, Col } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CalculatorForm from "../Forms/SavingsCalculator/CalculatorForm.jsx";
import SubscriptionImage from "assets/img/subscription_image.png";
import ShareImage from "assets/img/savings_share_image.png";
import CalculatorGridCard from "views/Components/CalculatorGridCard.jsx";
import "assets/css/demo.css";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

class SavingsCalculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "monthly",
      employeeCount: "",
      employeeCountError: "",
      price: "",
      priceError: "",
      opdAllocation: "",
      opdAllocationError: "",
      savingsOnOPD: "",
      savingsOnOPDError: "",
      medicineDelivery: "",
      medicineDeliveryError: "",
      homeLabService: "",
      doctorConsult: "",
      doctorConsultError: "",
      savingsSharePercent: "",
      savingsSharePercentError: "",
      calculationsComplete: false,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  setActiveTab(tab) {
    this.setState({ activeTab: tab });
  }

  handleFormDataChange = (formData) => {
    this.setState({
      ...formData,
    });
  };

  handleFormSubmit = (isValid) => {
    if (isValid) {
      this.setState({ calculationsComplete: true });
      this.state._notificationSystem.addNotification({
        title: <span data-notify="icon" className="pe-7s-calculator"></span>,
        message: <div>Savings Calculated Successfully.</div>,
        position: "br",
        level: "success",
        autoDismiss: 3,
      });
    }
  };

  calculateMonthlyCost = () => {
    const { employeeCount, price } = this.state;
    if (employeeCount && price) {
      return Number(employeeCount) * Number(price);
    }
    return 0;
  };

  calculateTotalPremium = () => {
    const { employeeCount, opdAllocation } = this.state;
    if (employeeCount && opdAllocation) {
      return Number(employeeCount) * Number(opdAllocation);
    }
    return 0;
  };

  calculateSavings = () => {
    const totalPremium = this.calculateTotalPremium();
    const { savingsOnOPD } = this.state;
    if (totalPremium && savingsOnOPD) {
      return Number(totalPremium) * Number(savingsOnOPD / 100);
    }
    return 0;
  };

  calculateBenifit = () => {
    const { medicineDelivery, homeLabService, doctorConsult } = this.state;
    if (medicineDelivery && homeLabService && doctorConsult) {
      return (
        Number(medicineDelivery * 200) +
        Number(homeLabService * 500) +
        Number(doctorConsult * 500)
      );
    }
    return 0;
  };

  calculateAnnualSavingsShare = () => {
    const { savingsSharePercent } = this.state;
    if (savingsSharePercent) {
      return (Number(savingsSharePercent) / 100) * this.calculateSavings();
    }
    return 0;
  };

  render() {
    const tabStyles = {
      border: "none",
      color: "#e74c3c",
      backgroundColor: "transparent",
      borderBottom: "2px solid #e74c3c",
      fontWeight: "bold",
    };

    this.state.activeTab === "monthly"
      ? (this.state.savingsOnOPD = 32.5)
      : (this.state.savingsOnOPD = 32);

    return (
      <div style={{ padding: "5px 15px", minHeight: "calc(100vh - 136px)" }}>
        <NotificationSystem ref="notificationSystem" style={style} />

        <div>
          <ul
            className="nav nav-tabs"
            style={{
              borderBottom: "0",
              position: "sticky",
              top: 0,
              zIndex: 1000,
              backgroundColor: "#f2f2f2",
            }}
          >
            <li className={this.state.activeTab === "monthly" ? "active" : ""}>
              <a
                href="#monthly"
                onClick={(e) => {
                  e.preventDefault();
                  this.setActiveTab("monthly");
                }}
                style={
                  this.state.activeTab === "monthly"
                    ? tabStyles
                    : { color: "black", borderBottom: "2px solid #cfcccc" }
                }
              >
                Monthly Annual Subscription
              </a>
            </li>
            <li className={this.state.activeTab === "annual" ? "active" : ""}>
              <a
                href="#annual"
                onClick={(e) => {
                  e.preventDefault();
                  this.setActiveTab("annual");
                }}
                style={
                  this.state.activeTab === "annual"
                    ? tabStyles
                    : { color: "black", borderBottom: "2px solid #cfcccc" }
                }
              >
                Annual OPD Savings Share
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div
              className={`tab-pane fade ${
                this.state.activeTab === "monthly" ? "in active" : ""
              }`}
              id="monthly"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column", // changed here for mobile style
                  width: "100%",
                  backgroundColor: "white",
                  paddingBottom: "20px",
                  borderRadius: "10px",
                }}
              >
                <Grid style={{ flex: 1 }} bsClass="calculatorFormContainer">
                  <Row>
                    <Col xs={12} md={5} style={{ marginBottom: "20px" }}>
                      {" "}
                      {/* added marginBottom */}
                      <CalculatorForm
                        activeTab={this.state.activeTab}
                        formData={this.state}
                        onFormDataChange={this.handleFormDataChange}
                        onFormSubmit={this.handleFormSubmit}
                      />
                    </Col>
                    <Col xs={12} md={7}>
                      <Row>
                        <Col
                          xs={12}
                          md={6}
                          style={{
                            display: "flex", // flex + flexDirection column + gap for mobile
                            flexDirection: "column",
                            gap: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          <CalculatorGridCard
                            title={"Monthly Cost"}
                            calculateFunction={this.calculateMonthlyCost()}
                            numberColor={"rgba(221, 135, 83, 1)"}
                          />
                          <CalculatorGridCard
                            title={"Forecasted Savings (Annually)"}
                            calculateFunction={this.calculateSavings()}
                            backgroundColor={"rgba(120, 230, 150, 0.1)"}
                            boxShadow={"0 1px 3px 5px rgba(120, 230, 150, 0.6)"}
                            borderColor={"rgba(120, 230, 150, 0.9)"}
                          />
                          <CalculatorGridCard
                            title={"Benefits"}
                            calculateFunction={this.calculateBenifit()}
                          />
                          <CalculatorGridCard
                            title={"Benefit Value"}
                            calculateFunction={
                              this.state.employeeCount * this.calculateBenifit()
                            }
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          style={{
                            display: "flex", // flex + flexDirection column + gap for mobile
                            flexDirection: "column",
                            gap: "20px",
                          }}
                        >
                          <CalculatorGridCard
                            title={"Total Premium"}
                            calculateFunction={this.calculateTotalPremium()}
                            numberColor={"rgba(221, 135, 83, 1)"}
                          />

                          <CalculatorGridCard
                            title={"Flash Earnings"}
                            calculateFunction={this.calculateMonthlyCost() * 12}
                          />

                          <div style={{ padding: "15px" }}>
                            <img
                              src={SubscriptionImage}
                              alt="Subscription Benefits"
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Grid>
              </div>
            </div>

            <div
              className={`tab-pane fade ${
                this.state.activeTab === "annual" ? "in active" : ""
              }`}
              id="annual"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column", // changed here for mobile style
                  width: "100%",
                  backgroundColor: "white",
                  paddingBottom: "20px",
                  borderRadius: "10px",
                }}
              >
                <Grid style={{ flex: 1 }} bsClass="calculatorFormContainer">
                  <Row>
                    <Col xs={12} md={5} style={{ marginBottom: "20px" }}>
                      {" "}
                      {/* added marginBottom */}
                      <CalculatorForm
                        activeTab={this.state.activeTab}
                        formData={this.state}
                        onFormDataChange={this.handleFormDataChange}
                        onFormSubmit={this.handleFormSubmit}
                      />
                    </Col>
                    <Col xs={12} md={7}>
                      <Row>
                        <Col
                          xs={12}
                          md={6}
                          style={{
                            display: "flex", // flex + flexDirection column + gap for mobile
                            flexDirection: "column",
                            gap: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          <CalculatorGridCard
                            title={"Monthly Cost"}
                            calculateFunction={this.calculateMonthlyCost()}
                            numberColor={"rgba(221, 135, 83, 1)"}
                          />
                          <CalculatorGridCard
                            title={"Forecasted Savings "}
                            calculateFunction={this.calculateSavings()}
                            backgroundColor={"rgba(120, 230, 150, 0.1)"}
                            boxShadow={"0 1px 3px 5px rgba(120, 230, 150, 0.6)"}
                            borderColor={"rgba(120, 230, 150, 0.9)"}
                          />
                          <CalculatorGridCard
                            title={"Flash Earnings"}
                            calculateFunction={
                              this.calculateMonthlyCost() * 12 +
                              this.calculateAnnualSavingsShare()
                            }
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          style={{
                            display: "flex", // flex + flexDirection column + gap for mobile
                            flexDirection: "column",
                            gap: "20px",
                          }}
                        >
                          <CalculatorGridCard
                            title={"Total Premium"}
                            calculateFunction={this.calculateTotalPremium()}
                            numberColor={"#dea533"}
                          />
                          <CalculatorGridCard
                            title={"Annual Savings Share"}
                            calculateFunction={this.calculateAnnualSavingsShare()}
                          />
                          <div style={{ padding: "15px" }}>
                            <img
                              src={ShareImage}
                              alt="Subscription Benefits"
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SavingsCalculator;
